import { CapacitorHttp, HttpResponse } from '@capacitor/core';

export const FirmwareUpdateError: { [key: string]: string } = {
  501: '<strong>Conflicting Command</strong>  Other command is being executed. Please try later.',
  502: 'Product Type Error. Command cannot be sent.',
  505: 'System error',
  // eslint-disable-next-line max-len
  510: '<strong>Parsing Failure</strong> Command sent, but device does not respond or response does not match the expectations. Please check actual device data.',
  511: 'Invalid version',
  530: '<strong>Command Failure</strong> Command cannot be sent. Please check network and try later.',
  570: 'Firmware package download failed',
  571: 'Firmware verification error',
  572: 'Firmware name error',
  573: 'Device interaction failed',
};

export interface StickLoggerInfo {
  inverterSerialNumber?: string;
  deviceSerialNumber?: string;
  firmwareVersion?: string;
};

export type StickLoggerPattern = Record<keyof StickLoggerInfo, RegExp>;


export const getStickLoggerInfo = async (originIp: string, username = 'admin', password = 'admin') => {
  const base64Credentials = btoa(`${username}:${password}`);
  const options = {
    url: `http://${originIp}/status.html`,
    headers: {
      Authorization: `Basic ${base64Credentials}`,
    },
  };

  const response: HttpResponse = await CapacitorHttp.get(options);
  if (response.status !== 200) {
    return null;
  }

  const data = response.data;
  const info: StickLoggerInfo = {};
  const patterns: StickLoggerPattern = {
    inverterSerialNumber: /var webdata_sn = \"(.*?)\";/,
    deviceSerialNumber: /var cover_mid = \"(.*?)\";/,
    firmwareVersion: /var cover_ver = \"(.*?)\";/,
  };

  for (const key in patterns) {
    if (!Object.prototype.hasOwnProperty.call(patterns, key)) {
      continue;
    }

    const keyOfInfo = key as keyof StickLoggerInfo;
    const match = data.match(patterns[keyOfInfo]);
    if (match && match[1]) {
      info[keyOfInfo] = match[1].trim().toUpperCase();
    }
  }

  return info;
};

export const getInverterUpdateInfo = async (originIp: string, username = 'admin', password = 'admin') => {
  const base64Credentials = btoa(`${username}:${password}`);
  const options = {
    url: `http://${originIp}/update_state.html`,
    headers: {
      Authorization: `Basic ${base64Credentials}`,
    },
  };

  const response: HttpResponse = await CapacitorHttp.get(options);
  if (response.status !== 200) {
    return null;
  }

  const data = response.data;
  const info: { [key: string]: string } = {};
  const patterns: { [key: string]: RegExp } = {
    state: /var state = \"(.*?)\";/,
  };

  // eslint-disable-next-line guard-for-in
  for (const key in patterns) {
    const match = data.match(patterns[key]);
    if (match && match[1]) {
      info[key] = match[1].trim().toUpperCase();
    }
  }

  return info;
};
